import Tag from '../components/ui/Tag';
import StackedCards from '../components/ui/StackedCards';
import ImageSlider from '../components/ui/ImageSlider';

const SAMPLE_IMAGES = [
  { src: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80', alt: 'Sample 1' },
  { src: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80', alt: 'Sample 2' },
  { src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80', alt: 'Sample 3' },
];

function PreviewSection({ title, children }) {
  return (
    <section className="preview-section">
      <div className="preview-section-inner">
        <span className="preview-section-label">{title}</span>
        {children}
      </div>
    </section>
  );
}

export default function PreviewPage() {
  return (
    <div className="preview-page">
      <div className="preview-hdr">
        <h1 className="preview-h1">Component Preview</h1>
        <p className="preview-sub">Design system reference — not shipped to production</p>
      </div>

      <PreviewSection title="Typography">
        <div className="preview-typo">
          <h1 className="preview-h1-ex">Display Heading</h1>
          <h2 className="preview-h2-ex">Section Heading</h2>
          <h3 className="preview-h3-ex">Sub Heading</h3>
          <p className="preview-body-lg">Body text at large size. Used for lead paragraphs and project overviews.</p>
          <p className="preview-body">Standard body text. Used for content sections, descriptions, and supporting copy.</p>
          <p className="preview-mono">Mono label — used for metadata, dates, section labels</p>
        </div>
      </PreviewSection>

      <PreviewSection title="Buttons">
        <div className="preview-btns">
          <button className="btn-primary">View Project</button>
          <button className="btn-secondary">Contact</button>
          <button className="btn-ghost">← Back to Work</button>
        </div>
      </PreviewSection>

      <PreviewSection title="Tags">
        <div className="preview-tags-row">
          <Tag>UX Design</Tag>
          <Tag>Mobile</Tag>
          <Tag variant="filled">UI/UX</Tag>
          <Tag variant="ghost">2024</Tag>
        </div>
      </PreviewSection>

      <PreviewSection title="Stacked Cards (Featured Project Interaction)">
        <div className="preview-sm-wrap">
          <StackedCards images={SAMPLE_IMAGES} />
        </div>
        <p className="preview-note">Hover to see subtle fan effect</p>
      </PreviewSection>

      <PreviewSection title="Image Slider (Illustration Modal)">
        <div className="preview-lg-wrap" style={{ height: '320px' }}>
          <ImageSlider images={SAMPLE_IMAGES} />
        </div>
      </PreviewSection>

      <PreviewSection title="Color Palette">
        <div className="preview-color-palette">
          {[50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].map((w) => (
            <div key={w} className="preview-swatch">
              <div
                className="preview-swatch-block"
                style={{ backgroundColor: `hsl(0 0% ${100 - w / 10}%)` }}
              />
              <span className="preview-swatch-label">{w}</span>
            </div>
          ))}
        </div>
      </PreviewSection>
    </div>
  );
}
